import { useEffect, useState } from "react";
import { Coords } from "google-map-react";

export default function useGetUserLocation() {
  const [location, setLocation] = useState<Coords>({
    lat: 51.5072,
    lng: 0.1276,
  });

  useEffect(() => {
    if (!navigator.geolocation) {
      console.warn("Geolocation not supported");
      return;
    }

    const onSuccess = (pos: GeolocationPosition) => {
      const { latitude, longitude } = pos.coords;
      setLocation({ lat: latitude, lng: longitude });
    };

    const onError = (err: GeolocationPositionError) => {
      console.error("Geolocation error:", err);

      switch (err.code) {
        case err.PERMISSION_DENIED:
          console.warn("Permission denied");
          break;
        case err.POSITION_UNAVAILABLE:
          console.warn("Position unavailable");
          break;
        case err.TIMEOUT:
          console.warn("Location timeout");
          break;
        default:
          console.warn("Unknown geolocation error");
      }

      setLocation({ lat: 10.99835602, lng: 77.01502627 });
    };

    navigator.geolocation.getCurrentPosition(onSuccess, onError, {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    });
  }, []);

  return location;
}
